export const DEFAULT_MAX_MEDIA_EVENTS_QUEUE_SIZE = 50;

export const DEFAULT_MEDIA_EVENTS_QUEUE_TIMEOUT = 10000;

export const MEDIA_TRACKING_LOG_MSG_PREFIX = 'MEDIA EVENT TRACKING [DEBUG]:';

export const MEDIA_TRACKING_DEBUG_LOGGING_ENABLED_MSG =
  'Media Event Tracking Debug Mode enabled, Media Tracking Events will be logged to console';

export const MEDIA_TRACKING_MOCK_API_CALLS_ENABLED_MSG =
  'Media Event Tracking Mock API calls enabled, Media Tracking Events will not be sent to backend';
